﻿{
  "registration": {
    "sectionTitle": "POSTO DI GUARDIA",
    "title": "Registrazione",
    "firstName": "Nome",
    "lastName": "Cognome",
    "company": "Società di trasporto",
    "companyPlaceholder": "Digita 3 lettere per cercare...",
    "plate": "Targa",
    "orderNumber": "Numero d'ordine",
    "photo": "Foto autista",
    "takePhoto": "Scatta una foto",
    "chooseFile": "Scegli un file",
    "security": "Ho letto e accettato il protocollo di sicurezza del sito",
    "securitySub": "DPI obbligatori · Zone vietate · Velocità max 10 km/h",
    "submit": "Convalida la registrazione",
    "success": "Registrazione completata con successo",
    "qrInstruction": "Scansiona questo QR Code per accedere alla mappa e ai servizi del sito dal tuo telefono o tablet.",
    "qrDone": "Registrazione completata",
    "nextRegistration": "Registrazione successiva",
    "errorRequired": "Questo campo è obbligatorio",
    "errorSecurity": "Devi accettare il protocollo di sicurezza",
    "phone": "Numero di telefono",
    "phonePlaceholder": "+39 312 345 678",
    "tankCapacity": "Capacità del serbatoio (litri)",
    "tankCapacityPlaceholder": "Es: 26000",
    "baffles": "Deflettori",
    "bafflesYes": "Sì",
    "bafflesNo": "No",
    "tare": "Tara del veicolo (kg)",
    "tarePlaceholder": "Es: 14500",
    "washCertificate": "Certificato di lavaggio",
    "washWashed": "Lavata",
    "washNotWashed": "Non lavata",
    "adr": "Conformità ADR",
    "adrCompliant": "Conforme",
    "adrNotCompliant": "Non conforme",
    "groupContact": "Contatto",
    "groupVehicle": "Veicolo e Serbatoio",
    "groupCompliance": "Conformità",
    "groupSecurity": "Sicurezza",
    "securityProtocol": "Protocollo di sicurezza del sito",
    "groupMedia": "Media",
    "fieldOptional": "Opzionale",
    "fieldRequired": "Obbligatorio",
    "wizardStepLabel": "Passo",
    "wizardStep1Title": "Quale operazione state effettuando?",
    "wizardStep1Subtitle": "Selezionate il tipo di intervento sul sito",
    "wizardExpedition": "Spedizione",
    "wizardLivraison": "Consegna",
    "wizardStep2Title": "Numero d'ordine",
    "wizardOrderLabel": "Numero d'ordine",
    "wizardOrderHintExpedition": "Esempio: AR… o 5…",
    "wizardOrderHintLivraison": "Esempio: 85…",
    "wizardOrderError": "Formato non valido per questo tipo di operazione",
    "wizardOrderUnknown": "Non ho / non conosco il numero d'ordine",
    "wizardOrderPlanned": "Ordine pianificato trovato — campi precompilati",
    "wizardValidate": "Conferma",
    "wizardBack": "Indietro",
    "wizardStep3Title": "Che tipo di veicolo guidate?",
    "wizardStep3Subtitle": "Selezionate il vostro veicolo",
    "wizardTank": "Cisterna",
    "wizardTrailer": "Rimorchio",
    "wizardModalIso": "Cisterna ISO?",
    "wizardModalContainer": "Container?",
    "wizardYes": "SÌ",
    "wizardNo": "NO",
    "chassisPlate": "Numero ISO",
    "containerPlate": "Numero container",
    "tareIso": "Tara ISO (kg)",
    "tareContainer": "Tara container (kg)",
    "pinTitle": "Codice PIN",
    "pinError": "Codice errato",
    "pinCancel": "Annulla",
    "capturePhoto": "Scatta",
    "guardAccess": "Accesso guardia",
    "trailerPlate": "Targa rimorchio"
  },
  "driver": {
    "title": "Benvenuto nel sito",
    "subtitle": "Seguire le istruzioni del posto di guardia",
    "yourPosition": "La tua posizione",
    "enableGps": "Attiva localizzazione",
    "gpsActive": "Localizzazione attiva",
    "gpsError": "Localizzazione non disponibile",
    "gpsPermission": "Consenti l'accesso alla posizione",
    "helpBtn": "Ho bisogno di aiuto",
    "helpSent": "Richiesta di aiuto inviata",
    "helpAlready": "La tua richiesta è stata ricevuta",
    "sessionExpired": "Sessione terminata",
    "sessionExpiredMsg": "La tua sessione è scaduta. Grazie per la visita.",
    "waitingMsg": "Attendi, un addetto ti assisterà a breve",
    "estimatedPassage": "Ora di passaggio stimata",
    "instruction": "Istruzione",
    "instructionClose": "Chiudi"
  },
  "incident": {
    "alertTitle": "ALLARME — EVACUARE SUBITO",
    "alertSubtitle": "Seguire immediatamente le indicazioni sulla mappa",
    "alertInstruction": "Recarsi al punto di raccolta più vicino",
    "safeNow": "Sono al sicuro",
    "normalMode": "Situazione tornata alla normalità",
    "evacuation": "Punto di evacuazione",
    "assembly": "Punto di raccolta",
    "firstAid": "Pronto soccorso"
  },
  "messages": {
    "title": "Messaggio dall'operatore",
    "placeholder": "Scrivi un messaggio all'autista...",
    "send": "Invia",
    "dictate": "Detta",
    "translatedTo": "Tradotto in",
    "noMessages": "Nessun messaggio inviato",
    "reactionSent": "Reazione inviata"
  }
}
